var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.87 291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b4250;\n      }\n\n      .cls-2 {\n        fill: #1a8f3f;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265,93.57,256.68,102a120.93,120.93,0,0,1-88.44,193.23q-4.14.27-8.22.27a120.44,120.44,0,0,1-89.79-39.87,7.5,7.5,0,0,1,11.13-10A106,106,0,0,0,240.93,106.17,7.51,7.51,0,0,1,241.35,96l13.08-13.08a5.31,5.31,0,0,0-7.5-7.5L233.34,89a7.49,7.49,0,0,1-9.81.69A105.61,105.61,0,0,0,172,69.24a7.5,7.5,0,0,1-6.69-7.44V37.62A7.5,7.5,0,0,1,172.68,30h7a5.31,5.31,0,1,0,0-10.62H140.31a5.31,5.31,0,0,0,0,10.62h6.87a7.5,7.5,0,0,1,7.5,7.5V61.8A7.51,7.51,0,0,1,148,69.24a106.11,106.11,0,0,0-63.84,31.29A7.52,7.52,0,0,1,73.44,90a121.22,121.22,0,0,1,66.24-34.71V45a20.31,20.31,0,0,1,.63-40.5h39.36A20.31,20.31,0,0,1,180.3,45V55.17A120.77,120.77,0,0,1,227.19,73.8l9-9a20.31,20.31,0,1,1,28.74,28.71h0Zm-63.42,50-19.23,19.23a25.35,25.35,0,1,1-10.62-10.62L191,132.9a7.51,7.51,0,0,1,10.62,10.62Zm-31.32,31A10.29,10.29,0,1,0,160,184.83,10.29,10.29,0,0,0,170.28,174.54ZM160,263.79a89.28,89.28,0,1,0-63-152.4A7.51,7.51,0,0,0,107.61,122a74.31,74.31,0,1,1,.09,105.09l-.09-.09A7.51,7.51,0,0,0,97,237.63,89,89,0,0,0,160,263.79Z",
    transform: "translate(-19.02 -4.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.55,216.36H78.6a7.5,7.5,0,1,0,0-15h-52a7.5,7.5,0,0,0,0,15Z",
    transform: "translate(-19.02 -4.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.28,172.47a7.5,7.5,0,0,0-7.5-7.5h-52a7.5,7.5,0,1,0,0,15H96.78A7.5,7.5,0,0,0,104.28,172.47Z",
    transform: "translate(-19.02 -4.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,136.11a7.5,7.5,0,0,0,7.5,7.5H78.6a7.5,7.5,0,0,0,0-15h-52a7.5,7.5,0,0,0-7.5,7.47Z",
    transform: "translate(-19.02 -4.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.2ff6c2cce8e77f58467ceb64a59edcc2.svg";
export { ForwardRef as ReactComponent };